import React, { useEffect, useState } from "react";
import api from "../api/axios";
import FinancialYearFilter from "../components/FinancialYearFilter";
import LedgerTable from "../components/LedgerTable";

function OpenbalanceList() {
  const [financialYear, setFinancialYear] = useState("2026");
  const [ledgers, setLedgers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const token = localStorage.getItem("accessToken");
  const branch_id = sessionStorage.getItem("selectedContext")
        ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
        : 0;

  // Fetch All ledgers
  const fetchLedgers = async (pageNumber = 1) => {
    setLoading(true);    
    try {
      const res = await api.get(`/ledger-list?page=${pageNumber}&branch_id=${branch_id}&per_page=1000`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Initialize debit & credit for each ledger
      const ledgersWithValues = res.data.data.map((l) => {
        const debit = l.opening_balance >= 0 ? l.opening_balance : 0;
        const credit = l.opening_balance < 0 ? Math.abs(l.opening_balance) : 0;
        return { ...l, debit, credit };
      });

      setLedgers(ledgersWithValues);
      setFinancialYear(res.data.latest_year || "2026");
      //setPage(res.data.current_page);
      //setLastPage(res.data.last_page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLedgers();
  }, []);

  const handleLedgerChange = (index, field, value) => {
    const updatedLedgers = [...ledgers];
    updatedLedgers[index][field] = value ? parseFloat(value) : 0;

    // Clear opposite side when user types
    if (field === "debit") updatedLedgers[index].credit = 0;
    else if (field === "credit") updatedLedgers[index].debit = 0;

    setLedgers(updatedLedgers);
  };

  // 🔹 Submit data to backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        financial_year: financialYear,
        ledgers: ledgers.map((l) => ({
          ledger: l.id,
          debit: parseFloat(l.debit || 0),
          credit: parseFloat(l.credit || 0),
        })),
      };

      await api.post("/update-opening-balance", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Opening balances saved successfully!");
      fetchLedgers(); // reload updated data
    } catch (err) {
      console.error("Error saving opening balances:", err);
      alert("Error saving balances!");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {/* Page Title */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Opening Balance</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a href="#">Accounts</a>
                </li>
                <li className="breadcrumb-item active">Opening Balance</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0 flex-grow-1">Manage your opening balance</h4>
                <button
                    type="submit"
                    className="btn btn-primary px-4 ms-auto"
                    disabled={saving || loading}
                  >
                    {saving ? "Updating..." : "Update"}
                </button>
              </div>
              <div className="card-body">
                {/* Filter */}
                <FinancialYearFilter
                  value={financialYear}
                  onChange={(e) => setFinancialYear(e.target.value)}
                />

                {/* Table */}
                <LedgerTable ledgers={ledgers} onChange={handleLedgerChange} loading={loading}/>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default OpenbalanceList;
